module.exports = __webpack_public_path__ + "img/23.5836d521.jpg";